import PropTypes from 'prop-types';

import Wheat from './allergene-wheat';
import Eggs from './allergene-egg';
import Peanuts from './allergene-peanuts';
import Fish from './allergene-fish';
import Crustacean from './allergene-crustacean';
import Lupines from './allergene-lupines';
import Milk from './allergene-milk';
import Nuts from './allergene-nuts';
import Sulphite from './allergene-sulphite';
import Celery from './allergene-celery';
import Mustard from './allergene-mustard';
import Sesame from './allergene-sesame';
import Soy from './allergene-soy';
import Molluscs from './allergene-molluscs';

const AllergeneIcon = (props) => {
  switch (props.name) {
    case 'GLUTEN-WHEAT':
    case 'GLUTEN-ROGGEN':
    case 'GLUTEN-GERSTE':
    case 'GLUTEN-HAFER':
    case 'GLUTEN-DINKEL':
      return <Wheat {...props} />;
    case 'FISH':
      return <Fish {...props} />;
    case 'CRUSTACEAN':
      return <Crustacean {...props} />;
    case 'SULPHITE':
      return <Sulphite {...props} />;
    case 'CELERY':
      return <Celery {...props} />;
    case 'MILK':
      return <Milk {...props} />;
    case 'SESAME':
      return <Sesame {...props} />;
    case 'NUTS-ALMOND':
    case 'NUTS-WALNUTS':
    case 'NUTS-CASHEW':
    case 'NUTS-PECAN':
    case 'NUTS-PARA':
    case 'NUTS-PISTACHIO':
    case 'NUTS-MACADAMIA':
    case 'NUTS-QUEENSLAND':
    case 'HAZELNUT':
      return <Nuts {...props} />;
    case 'PEANUTS':
      return <Peanuts {...props} />;
    case 'EGGS':
      return <Eggs {...props} />;
    case 'LUPINES':
      return <Lupines {...props} />;
    case 'MUSTARD':
      return <Mustard {...props} />;
    case 'SOY':
      return <Soy {...props} />;
    case 'MOLLUSCS':
      return <Molluscs {...props} />;
    default:
      return <Wheat {...props} />;
  }
};

AllergeneIcon.propTypes = {
  style: PropTypes.object.isRequired,
  name: PropTypes.string,
  viewBox: PropTypes.string,
};

export default AllergeneIcon;
